import React, { useState } from "react";
import Swal from 'sweetalert2';
import { apiHandler } from '../../api/apihandler';
import { BILLING_PAD_PAY } from '../../api/constants';
import LoaderModal from '../loaderModal';

// Phase 52 - Stripe ACSS Debit/Canadian PAD payment initiation, for a
// parent whose mandate is already ACTIVE. Unlike StripeCardForBilling, the
// amount is NEVER supplied by this component or any client - the backend
// (PadController.pay) computes it itself from the current outstanding
// balance. This only confirms the parent's intent to initiate a debit and
// shows the resulting PROCESSING state, never a synchronous "paid" result
// - PAD settlement is asynchronous and happens later via webhook.
function PadPayForBilling({ outstanding, onSuccess, onCancel }) {
    const [showLoader, setShowLoader] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const submitPadPayment = async () => {
        if (submitting) {
            return;
        }
        setSubmitting(true);
        try {
            setShowLoader(true);
            const res = await apiHandler(BILLING_PAD_PAY, "POST", {});

            if (res?.isAxiosError || (res?.response && res?.data === undefined)) {
                Swal.fire({
                    title: 'Payment Failed',
                    text: res?.response?.data?.data?.message || res?.response?.data?.message || 'Unable to initiate bank payment. Please try again.',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                });
                return;
            }

            if (res.data?.response?.status === 200 || res.data?.response?.status === 201) {
                Swal.fire({
                    title: 'Bank Payment Submitted',
                    text: 'Your bank payment has been submitted and is processing. This can take several business days to complete - we will update your balance once it settles.',
                    icon: 'success',
                    confirmButtonText: 'Okay'
                });
                onSuccess && onSuccess();
            } else {
                Swal.fire({
                    title: 'Payment Failed',
                    text: res?.data?.data?.message || 'Unable to initiate bank payment. Please try again.',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                });
            }
        } catch (error) {
            Swal.fire({
                title: 'Payment Failed',
                text: 'Something went wrong while initiating your bank payment. Please try again.',
                icon: 'error',
                confirmButtonText: 'Okay'
            });
        } finally {
            setShowLoader(false);
            setSubmitting(false);
        }
    };

    return (
        <>
            <LoaderModal showLoader={showLoader} loaderData="Submitting your bank payment..." />
            <p className="text-muted small">
                This will debit your authorized bank account for the full outstanding balance of
                ${Number(outstanding || 0).toFixed(2)}. Bank payments are processed over several business
                days, not instantly.
            </p>
            <div className="d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-outline-secondary" disabled={submitting} onClick={onCancel}>
                    Cancel
                </button>
                <button type="button" className="btn btn-primary" disabled={submitting} onClick={submitPadPayment}>
                    {submitting ? 'Submitting...' : `Pay $${Number(outstanding || 0).toFixed(2)} by Bank`}
                </button>
            </div>
        </>
    );
}
export default PadPayForBilling;
